/*
 * (c) Copyright, 2025, Medidata Solutions Worldwide, Inc. All rights reserved.
 */
export interface RcmTableData {
  isGridView: boolean
  page: number
  hasNextPage: boolean
  defaultSortBy: string | null
  defaultSortDesc: boolean
  entries: any[]
  total: number
  isLoading: boolean
  persistenceKey: string | null
  load: (params: { sortDesc: boolean; sortBy: string; pageSize: number; pageStart: number }) => void
  refreshTable: (goToPage?: number | null, isSilent?: boolean, userId?: number | null) => void
}

/*
 * (c) Copyright, 2025, Medidata Solutions Worldwide, Inc. All rights reserved.
 */

import React from 'react'
import { RcmTableDataContext, RcmTableDataContextValue } from '../components/rcm-table/RcmTableDataContext'

export const useRcmTableData = (): RcmTableDataContextValue => {
  const context = React.useContext(RcmTableDataContext)
  if (context === null) {
    throw new Error('useRcmTableData must be used within RcmTableDataWrapper')
  }
  return context
}
